import * as React from "react"

const PaletteClose = () => {
  return (
    <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.54 4.08A10.609 10.609 0 0010.91 1a10 10 0 10-.05 20 2.58 2.58 0 002.53-1.89 2.52 2.52 0 00-.57-2.28.499.499 0 01.37-.83h1.65A6.15 6.15 0 0021 10.33a8.48 8.48 0 00-2.46-6.25zM14.88 14h-1.65a2.49 2.49 0 00-1.87 4.15.49.49 0 01.12.49c-.05.21-.28.34-.59.36a8.001 8.001 0 01-7.82-9.11A8.1 8.1 0 0110.92 3H11a8.47 8.47 0 016.1 2.48 6.499 6.499 0 011.9 4.77A4.17 4.17 0 0114.88 14z"
        fill="#fff"
      />
      <path
        d="M11 7a1.5 1.5 0 100-3 1.5 1.5 0 000 3zM14.25 6.2a1.5 1.5 0 101.5 2.597 1.5 1.5 0 00-1.5-2.597zm-6.5 0a1.5 1.5 0 10-1.498 2.6A1.5 1.5 0 007.75 6.2zm-2.59 4.06a1.5 1.5 0 102.08.4 1.49 1.49 0 00-2.08-.4z"
        fill="#fff"
      />
    </svg>
  )
}

export default PaletteClose
